import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KupariListComponent } from './kupari-list.component';
@NgModule({
  declarations: [
    KupariListComponent
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    KupariListComponent
  ]
})
export class KupariListModule { }

